import { IoReload } from 'react-icons/io5';
import { FaAngleLeft } from 'react-icons/fa6';
import './PageSubHeader.css';
import DefaultButton from '../Buttons/Default';
import IconButton from '../Buttons/IconButton';
import { Badge } from 'reactstrap';

export default function PageSubHeader({ title, breadcrumb, onBack, avatar, children, onReload, dataTotal }) {
  return (
    <div className="page-subheader">
      <div className="page-subheader-left">
        {onBack && (
          <button className="subheader-back-btn" onClick={onBack} type="button">
            <FaAngleLeft size={14} />
          </button>
        )}
        {avatar}
        {breadcrumb ? (
          <div className="page-subheader-breadcrumb">
            {breadcrumb.map((item, i) => (
              <span key={i} className="d-flex align-items-center gap-1">
                {i > 0 && <span className="breadcrumb-sep">/</span>}
                <span className={i === breadcrumb.length - 1 ? 'breadcrumb-current' : 'breadcrumb-parent'}>
                  {item}
                </span>
              </span>
            ))}
          </div>
        ) : (
          <h5 className="page-subheader-title">
            {title}
            {dataTotal && Number(dataTotal) > 0 ?
              <Badge color="info" className="ms-2 fw-bold">{dataTotal}</Badge>
            :
              null
            }
          </h5>
        )}

        {onReload &&
          <IconButton size="sm" color="light" outline onClick={onReload}>
            <IoReload />
          </IconButton>
        }
      </div>
      {children && (
        <div className="page-subheader-right">
          {children}
        </div>
      )}
    </div>
  );
}
